var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 264,
    height: 264,
    viewBox: "0 0 264 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1220_16057)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 264,
    height: 264,
    rx: 132,
    fill: "#EFF0F6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M62.4169 198.216L2.64363 216.574L-10.9551 197.924L-22.6053 164.34L23.8206 157.74L79.3372 139.67L97.5899 142.052L109.096 163.804L106.174 186.205L78.1806 200.272L62.4169 198.216Z",
    fill: "#00BA88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.578 59.3477L115.455 -8.6852",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3287 26.5214L111.233 23.6728",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.489 140.054C237.489 140.054 227.97 120.719 232.206 109.397C240.445 87.3736 300.862 100.648 300.862 100.648",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.76 158.418L221.048 169.129L202.582 71.3716",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6454 103.884L31.3638 77.2985",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6815 134.618L44.7806 119.973",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7633 272.454L54.3364 214.881L81.4271 214.197L108.266 202.51L116.02 227.148",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.4014 110.556L95.7514 97.9348",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.506 258.213L244.113 260.737L235.853 252.909L246.386 243.314L265.902 242.485",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.208 295.945C268.208 295.945 263.865 253.962 267.85 227.551C270.353 210.959 278.329 202.667 278.348 185.887C278.373 164.548 261.181 97.5806 261.181 97.5806",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2854 49.6439L93.9635 43.2601",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.785 11.7298L142.463 5.34602",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.824 178.69L162.503 172.306",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-74.7339 246.982C-74.7339 246.982 -33.3039 263.669 -7.02583 258.347C4.57853 255.997 21.3638 247.707 21.3638 247.707",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.231 301.499C220.231 301.499 221.846 267.668 221.568 245.983C221.287 224.065 216.983 211.773 218.756 189.926C219.417 181.784 220.936 177.336 221.463 169.184C223.41 139.072 214.937 89.8597 214.937 89.8597L301.079 69.8787",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.686 188.34C290.686 188.34 247.539 187.113 220.308 190.971C188.826 195.431 170.233 198.035 141.632 211.926C122.663 221.138 96.4319 241.468 96.4319 241.468",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.248 299.187C157.248 299.187 178.769 185.469 181.713 111.682C182.513 91.6352 181.41 80.347 182.509 60.3144C184.602 22.1418 195.174 -36.7568 195.174 -36.7568",
    stroke: "white",
    strokeWidth: 18.3837
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1515 257.482L77.4577 238.149L162.084 249.19",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-97.2401 -10.8987L-44.9339 -30.2317L39.6923 -19.1902",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.093 58.0413L158.399 38.7083L243.025 49.7498",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.803 211.819L110.832 72.9015",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6906 82.4815L2.71951 -56.4358",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.633 39.852L127.662 -99.0652",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3613 13.7637L38.3902 -125.154",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-64.5969 233.959C-64.5969 233.959 -37.1023 244.786 -19.2898 242.402C-8.27375 240.927 7.94539 234.142 7.94539 234.142",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.908 279.996L84.2383 270.254L29.6959 280.857",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.842 301.352C173.842 301.352 195.363 187.634 198.307 113.847C199.106 93.8004 198.003 82.5121 199.102 62.4795C201.196 24.3069 211.767 -34.5917 211.767 -34.5917",
    stroke: "white",
    strokeWidth: 18.3837
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-84.5401 102.257C-84.5401 102.257 1.22842 81.1521 49.0744 74.1249C111.146 65.0084 151.149 85.7299 209.274 62.1188C251.488 44.9708 317.928 -13.9905 317.928 -13.9905",
    stroke: "white",
    strokeWidth: 18.3837
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.1455 149.081L22.3424 143.203L39.7292 152.221C39.7292 152.221 59.3879 147.171 69.9947 140.138C79.0962 134.103 83.6496 129.554 90.2322 120.84C105.721 100.338 106.972 57.2085 106.972 57.2085L38.5814 -20.062",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1715 143.311L23.0637 134.437L54.1043 132.58L73.5482 116.132L97.2834 131.463L122.012 126.252",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-80.0182 36.0025L-80.1261 27.1286L-49.0854 25.272L-29.6416 8.82359L-5.90629 24.1554L18.8218 18.9438",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.746 128.117L270.126 132.499L221.86 143.499",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.308 27.8491L228.611 17.3889L267.606 22.4767",
    stroke: "white",
    strokeWidth: 6.1279
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2917 212.932L8.09183 197.457L0.264469 186.31",
    stroke: "#00966D",
    strokeWidth: 3.06395,
    strokeDasharray: "15.32 6.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.50765 215.582L66.9985 195.438L85.6664 188.17L98.0036 180.92L99.7897 167.23L93.3874 151.628L75.0624 153.034L50.3343 158.246L42.4157 173.667L36.1206 186.346L24.7035 186.544L11.6453 183.153L-12.0006 189.771",
    stroke: "#00966D",
    strokeWidth: 3.06395,
    strokeDasharray: "15.32 6.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.9058 175.631L9.75224 168.562L22.6303 166.867L33.7589 162.412L47.0336 164.144",
    stroke: "#00966D",
    strokeWidth: 3.06395,
    strokeDasharray: "15.32 6.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3234 208.856L28.7428 197.619L27.2462 186.455",
    stroke: "#00966D",
    strokeWidth: 3.06395,
    strokeDasharray: "15.32 6.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0655 201.858L36.12 186.347",
    stroke: "#00966D",
    strokeWidth: 3.06395,
    strokeDasharray: "15.32 6.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6303 166.867L11.2307 183.099",
    stroke: "#00966D",
    strokeWidth: 3.06395,
    strokeDasharray: "15.32 6.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3613 174.081L62.8328 169.158L79.3361 168.78",
    stroke: "#00966D",
    strokeWidth: 3.06395,
    strokeDasharray: "15.32 6.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.7825 188.477L75.5312 152.674",
    stroke: "#00966D",
    strokeWidth: 3.06395,
    strokeDasharray: "15.32 6.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2164 285.727C28.2164 285.727 23.6833 260.975 17.324 246.335C10.3897 230.373 1.37196 224.187 -6.44651 208.639C-27.8459 166.081 -27.4596 136.594 -30.5025 89.0565C-33.9078 35.8557 -18.6654 -46.9373 -18.6654 -46.9373",
    stroke: "white",
    strokeWidth: 18.3837
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 162.5C122.5 154.375 108 135 108 124C108 110.75 118.625 100 132 100C145.25 100 156 110.75 156 124C156 135 141.375 154.375 134.875 162.5C133.375 164.375 130.5 164.375 129 162.5Z",
    fill: "#ED5A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.573 123.805C139.427 123.805 139.28 123.805 139.134 123.805C138.183 123.805 137.341 123.402 136.756 122.744C136.171 123.402 135.329 123.805 134.378 123.805C133.427 123.805 132.549 123.402 131.963 122.744C131.415 123.402 130.537 123.805 129.585 123.805C128.634 123.805 127.793 123.402 127.207 122.744C126.622 123.402 125.78 123.805 124.829 123.805C124.683 123.805 124.537 123.805 124.39 123.805C122.341 123.512 121.39 121.134 122.488 119.415L124.573 116.122C124.756 115.793 125.085 115.61 125.451 115.61H138.512C138.878 115.61 139.207 115.793 139.39 116.122L141.476 119.415C142.573 121.134 141.622 123.512 139.573 123.805ZM139.72 124.939C139.866 124.939 140.049 124.902 140.195 124.866V132C140.195 133.317 139.134 134.341 137.854 134.341H126.146C124.829 134.341 123.805 133.317 123.805 132V124.866C123.915 124.902 124.061 124.939 124.207 124.939H124.244C124.427 124.976 124.61 124.976 124.829 124.976C125.268 124.976 125.707 124.939 126.146 124.793V129.659H137.854V124.793C138.256 124.939 138.695 124.976 139.134 124.976C139.354 124.976 139.537 124.976 139.72 124.939Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 260,
    height: 260,
    rx: 130,
    stroke: "#EFF0F6",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1220_16057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 264,
    height: 264,
    rx: 132,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.d717231991120b84b23ce24c5f189db9.svg";
export { ForwardRef as ReactComponent };